(function () {
  function initProductSwiperSliders() {
    if (typeof Swiper === 'undefined') {
      setTimeout(initProductSwiperSliders, 300);
      return;
    }

    document.querySelectorAll('[data-product-swiper-slider]').forEach(function (slider) {
      if (slider.classList.contains('swiper-initialized')) return;

      var nextBtn = slider.querySelector('[data-swiper-next]');
      var prevBtn = slider.querySelector('[data-swiper-prev]');

      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 12,
        loop: false,
        watchOverflow: true,

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },

        breakpoints: {
          0: {
            slidesPerView: 2,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 20
          }
        }
      });
    });
  }

  function observeDynamicSections() {
    initProductSwiperSliders();

    var observer = new MutationObserver(function () {
      initProductSwiperSliders();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', observeDynamicSections);

  document.addEventListener('shopify:section:load', function () {
    initProductSwiperSliders();
  });

  window.addEventListener('load', function () {
    initProductSwiperSliders();
  });
})();